const RECHARGE_URL = 'https://checkout.rechargeapps.com/r/checkout';

/**
 * Used to create a Recharge checkout URL
 *
 * Based on: https://support.rechargepayments.com/hc/en-us/articles/360008682694-Redirect-to-checkout-from-AJAX-cart
 *
 * @param {*} customerId
 * @param {*} customerEmail
 * @param {*} cartToken
 * @param {*} shopDomain
 */
export const createRechargeCheckoutURL = (
  customerId,
  customerEmail,
  cartToken,
  shopDomain
) => {
  const paramString = Object.entries({
    customer_id: customerId,
    customer_email: customerEmail,
    cart_token: cartToken,
    myshopify_domain: shopDomain
  })
    .map(entry => entry.map(encodeURIComponent).join('='))
    .join('&');

  return `${RECHARGE_URL}?${paramString}`;
};

export const populateSubscriptionProperties = (
  selectedSubscriptionFrequency,
  subscribeShippingIntervalUnitType
) => {
  return {
    shipping_interval_frequency: selectedSubscriptionFrequency,
    shipping_interval_unit_type: subscribeShippingIntervalUnitType.toLowerCase()
  };
};

export const populateCartAttributes = (
  productHandle,
  quantity,
  selectedSubscriptionFrequency,
  subscribeShippingIntervalUnitType,
  context,
  selectedFreeGift,
  upSell,
  selectedUpsellProductQuantity
) => {
  const cartAttributes = {
    'subscribe-shipping-interval-frequency': selectedSubscriptionFrequency,
    'subscribe-shipping-interval-unit-type': subscribeShippingIntervalUnitType,
    'is-subscription-builder-ready': true
  };

  if (productHandle) {
    cartAttributes[`${context}--${productHandle}--quantity`] = quantity;
  }

  if (context === 'machine') {
    cartAttributes['selected-machine-handle'] = productHandle;

    if (selectedFreeGift && selectedFreeGift.handle) {
      cartAttributes[`freegift--${selectedFreeGift.handle}`] = 1;
    }

    if (upSell && selectedUpsellProductQuantity) {
      cartAttributes[
        `upsell--${upSell.handle}--quantity`
      ] = selectedUpsellProductQuantity;
    }
  }

  return cartAttributes;
};
